import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENTID || '',
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANTID || ''}`,
        redirectUri: '/',
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
};

export const pca = new PublicClientApplication(msalConfig);

export async function initializeMsal() {
    try {
        await pca.initialize();
        console.log('MSAL inicializado com sucesso.');
    } catch (error) {
        console.error('Erro ao inicializar o MSAL:', error);
    }
}

export async function getTokenMicro() {
    try {
        await pca.initialize();
        const accounts = pca.getAllAccounts();

        if (accounts.length === 0) {
            throw new Error('Nenhuma conta ativa encontrada. O usuário precisa fazer login.');
        }

        const response = await pca.acquireTokenSilent({
            scopes: ['https://graph.microsoft.com/.default'],
            account: accounts[0],
        });

        return response.accessToken;
    } catch (error) {
        console.error('Erro ao adquirir token:', error);
        throw error;
    }
}
